import React, {useEffect, useState} from 'react';
import styles from './ComponentTermsBlock.scss';
import {_scrollTo} from "../../common/helpers/HelperAnimation";

/**
 *
 * @param {string} title
 * @param {string} id
 * @param {Element} [children]
 * @param {string} [link]
 * @returns {Element}
 * @constructor
 */
export default function ComponentTermsBlock({title, id, children, link}) {

	const [visible, setVisible] = useState(false);

	const onClick = () => {
		if (!link) {
			location.hash = '#' + id;
			setVisible(!visible);
		}
	}

	useEffect(() => {
		const hash = window.location.hash.replace('#', '');
		if (hash === id) {
			setVisible(true);
			_scrollTo(document.getElementById('gtc_' + id), -250);
		}
	}, []);

	return (
	  <section className={styles.term} id={'gtc_' + id}>
		  <div>
			  <h2>
				  {!!link && (<a href={link} target='_blank' rel='noopener noreferrer'>{title}</a>)}
				  {!link && (<a onClick={onClick}>{title}</a>)}
			  </h2>
			  {!!children && visible && (
				<div className={styles.termContent}>
					{children}
				</div>
			  )}
		  </div>
	  </section>
	)
}